import "./LoadScreen.scoped.scss";
import load_img from "../../img/top/loading.png";

import button_illust_out from "../../img/buttons/illust_out.png";
import button_illust_on from "../../img/buttons/illust_on.png";
import button_costume_out from "../../img/buttons/costume_out.png";
import button_costume_on from "../../img/buttons/costume_on.png";
import button_message_out from "../../img/buttons/message_out.png";
import button_message_on from "../../img/buttons/message_on.png";
import button_quiz_out from "../../img/buttons/quiz_out.png";
import button_quiz_on from "../../img/buttons/quiz_on.png";
import logo from "../../img/top/title_logo.png";
import top_illust from "../../img/top/logo.png";
import { useRef, useState } from "react";
import AppTempolaly from "../../AppTempolaly";

interface Props {
  onCompleted: () => void;
}

function Progress(prop: { loader: Loader }) {
  const [progress, setProgress] = useState(prop.loader.progress);
  prop.loader.onProgressUpdate = () => {
    setProgress(prop.loader.progress);
  };
  return <p>{Math.floor(progress * 100.0)}%</p>;
}

export default function LoadScreen(props: Props) {
  const bg = useRef<HTMLDivElement>(null);
  const icons = useRef<HTMLDivElement>(null);

  if (!AppTempolaly.requestPreload) {
    props.onCompleted();
    return <div></div>;
  }

  const fadeout = new FadeoutAnim(0.5, (amount) => {
    if (bg.current) {
      const mainColor = "#ffe592";
      const subColor = "#f1c180";
      const invert = 1.0 - amount;
      const code = `linear-gradient(
        -45deg,
        ${mainColor} ${0}%,
        ${mainColor} ${0 + 25 * invert}%,
        #FFFFFF00 ${0 + 25 * invert}%,
        #FFFFFF00 ${0 + 25}%,
        ${subColor} ${25}%,
        ${subColor} ${25 + 25 * invert}%,
        #FFFFFF00 ${25 + 25 * invert}%,
        #FFFFFF00 ${25 + 25}%,
        ${mainColor} ${50}%,
        ${mainColor} ${50 + 25 * invert}%,
        #FFFFFF00 ${50 + 25 * invert}%,
        #FFFFFF00 ${50 + 25}%,
        ${subColor} ${75}%,
        ${subColor} ${75 + 25 * invert}%,
        #FFFFFF00 ${75 + 25 * invert}%,
        #FFFFFF00 ${75 + 25}%
      )`;
      const style = bg.current.style;
      style.backgroundImage = code;
      style.visibility = amount === 1.0 ? "hidden" : "visible";
    }

    if (icons.current) {
      const invert = 1.0 - amount;
      const style = icons.current.style;
      style.opacity = `${invert * invert * 100.0}%`;
    }
    AppTempolaly.requestPreload = false;
    props.onCompleted();
  });

  const loadStart = new Date();
  const loader = new Loader(() => {
    // load画面を最低でも以下の指定時間分表示しておく
    const minDisplayTime = 1000;
    const loadEnd = new Date();
    const millisecond = loadEnd.getTime() - loadStart.getTime();
    const waitTime = Math.floor(Math.max(minDisplayTime - millisecond, 0));
    if (waitTime > 0) {
      setTimeout(() => {
        fadeout.raiseFadeout();
      }, waitTime);
    } else {
      fadeout.raiseFadeout();
    }
  });

  return (
    <div className="bg_full" ref={bg}>
      <div className="icon_container" ref={icons}>
        <img
          src={load_img}
          alt="loading..."
          className="icon"
          loading="eager"
        ></img>
        <Progress loader={loader}></Progress>
      </div>
    </div>
  );
}

class Loader {
  private static preloadFiles = [
    load_img,
    button_illust_out,
    button_illust_on,
    button_costume_out,
    button_costume_on,
    button_message_out,
    button_message_on,
    button_quiz_out,
    button_quiz_on,
    logo,
    top_illust,
  ];
  private preloadedNum = 0;
  private readonly preloadedNumMax;

  public onProgressUpdate: (() => void) | null = null;

  constructor(private readonly onProgressComplete: () => void) {
    this.preloadedNumMax = Loader.preloadFiles.length;
    for (const path of Loader.preloadFiles) {
      this.load(path);
    }
  }
  private load(path: string) {
    const image = new Image();
    image.onload = () => {
      this.preloadedNum++;
      this.update();
    };
    image.onerror = () => {
      // 何かしらの問題で失敗して開けないのは悲しいので成功扱いに
      this.preloadedNum++;
      this.update();
    };
    image.src = path;
  }

  private update() {
    this.onProgressUpdate && this.onProgressUpdate();
    if (this.preloadedNum === this.preloadedNumMax) {
      this.onProgressComplete();
    }
  }

  public get progress() {
    return this.preloadedNum / this.preloadedNumMax;
  }
}

// 直接スタイルを書き換えるので再レンダリングはされない
class FadeoutAnim {
  private interval_id: NodeJS.Timeout | null = null;
  private totalTime = 0;
  private readonly interval_ms = 16;

  constructor(
    private readonly duration: number,
    private readonly update: (amount: number) => void
  ) {}

  public raiseFadeout() {
    if (this.interval_id) {
      return;
    }

    this.totalTime = 0.0;
    this.interval_id = setInterval(() => {
      this.totalTime += this.interval_ms / 1000.0;

      // 指定時間定期再呼び出しが終わったらIntervalを解除する。
      if (this.totalTime >= this.duration) {
        this.totalTime = this.duration;
        if (this.interval_id) {
          clearInterval(this.interval_id);
          this.interval_id = null;
        }
      }

      // 最後に設定
      this.update(this.totalTime / this.duration);
    }, this.interval_ms);
  }
}
